import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
const waterwheelWork = {
  waterwheelWork: {
    name: 'waterwheelWork',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'stepForm',
      'dialogForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'waterwheelWork/getWaterwheelWorkList',
    deleteFun: 'waterwheelWork/deleteWaterwheelWork',
    getDetailFun: 'waterwheelWork/getWaterwheelWorkInfo',
    addFun: 'waterwheelWork/addWaterwheelWork',
    editFun: 'waterwheelWork/editWaterwheelWork',
    detailPage: [
      {
        buttonName: '新增',
        type: 'stepForm',
        name: 'waterwheelWork',
        step: 'waterwheelWorkInfo',
        theme: 'waterwheelWork',
        label: '水车作业登记'
      },
      {
        buttonName: '查看',
        type: 'stepForm',
        name: 'waterwheelWork',
        checkType: 'checkByUid',
        checkFun: 'waterwheelWork/getWaterwheelWorkInfo',
        step: 'waterwheelWorkInfo',
        theme: 'waterwheelWork',
        label: '查看水车作业信息'
      },
      {
        buttonName: '结束作业',
        type: 'stepForm',
        name: 'waterwheelWork',
        checkType: 'checkByUid',
        checkFun: 'waterwheelWork/getWaterwheelWorkInfo',
        step: 'waterwheelWorkInfo',
        theme: 'waterwheelWork',
        label: '结束水车作业登记',
        pageStatus: 'edit'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      laborCompanyUid: null,
      isFinished: '',
      period: [],
      start: '',
      end: '',
      query: ''
    },
    selectData: [
      {
        key: 'laborCompanyUid',
        label: '所属劳务公司',
        type: 'select',
        options: (params) => {
          const source =
            (params.state.bidSection &&
              params.state.bidSection.laborCompanyNames) ||
            []
          const laborCompanys = JSON.parse(JSON.stringify(source))
          laborCompanys.unshift({
            value: '',
            label: '项目直管'
          })
          return laborCompanys
        },
        checkByValue: true
      },
      {
        key: 'isFinished',
        label: '是否完成',
        type: 'select',
        options: (params) => {
          return params.dictionarys.isTrue
        },
        span: 5
      },
      {
        key: 'period',
        label: '作业日期',
        type: 'time',
        timetype: 'daterange',
        span: 8
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '车牌号/驾驶员',
        span: 5
      }
    ],
    indexColumn: true,
    rowData: (params) => {
      const list =
        params.state.waterwheelWork &&
        params.state.waterwheelWork.waterwheelWorkList
      return (list && list.result) || []
    },
    rowTotal: (params) => {
      const list =
        params.state.waterwheelWork &&
        params.state.waterwheelWork.waterwheelWorkList
      return (list && list.totalSize) || 0
    },
    columns: [
      { prop: 'carCode', label: '车牌号', width: '' },
      { prop: 'driverName', label: '驾驶员', width: '' },
      { prop: 'ratedWaterLevel', label: '额定水位(m)', width: '' },
      { prop: 'startTime', label: '开始时间', width: '160px' },
      { prop: 'startingWaterLevel', label: '开始水位(m)', width: '' },
      {
        prop: 'startPosition',
        label: '开始位置',
        width: '200px',
        overflow: false
      },
      {
        prop: 'isFinished',
        label: '是否完成',
        width: '',
        tag: (params) => {
          return params.dictionarys.isTrue
        }
      },
      { prop: 'endTime', label: '结束时间', width: '160px' },
      { prop: 'endingWaterLevel', label: '结束水位(m)', width: '' },
      {
        prop: 'endPosition',
        label: '结束位置',
        width: '200px',
        overflow: false
      },
      {
        label: '操作',
        buttons: setTableButtons(['查看', '结束作业', '删除']),
        width: '240px'
      }
    ],
    hasPagination: true,
    formParams: {
      uid: '',
      orgUid: (params) => {
        return params.orgValue
      },
      orgName: (params) => {
        return params.orgName
      },
      laborCompanyUid: '',
      laborCompanyName: '',
      carUid: '',
      carCode: '',
      driverName: '',
      ratedWaterLevel: null,
      startTime: '',
      startingWaterLevel: null,
      startPosition: '',
      startGps: null,
      endTime: '',
      endingWaterLevel: null,
      endPosition: '',
      endGps: null,
      isFinished: '否'
    },
    formRules: {
      carInfo: [
        {
          required: true,
          message: '请选择当前作业水车',
          trigger: 'blur'
        }
      ],
      driverName: [
        {
          required: true,
          message: '驾驶员姓名不能为空',
          trigger: 'blur'
        }
      ],
      startPosition: [
        {
          required: true,
          message: '开始作业位置不能为空',
          trigger: 'blur'
        }
      ],
      endPosition: [
        {
          required: (params) => {
            return params.pageStatus === 'edit'
          },
          message: '结束作业位置不能为空',
          trigger: 'blur'
        }
      ],
      ratedWaterLevel: [
        {
          required: true,
          message: '额定水位不能为空',
          trigger: 'change'
        }
      ],
      startingWaterLevel: [
        {
          required: true,
          message: '开始水位不能为空',
          trigger: 'blur'
        },
        {
          validator: (params) => {
            return params.validate.validateStartingWaterLevel
          },
          trigger: 'change'
        }
      ],
      endingWaterLevel: [
        {
          required: (params) => {
            return params.pageStatus === 'edit'
          },
          message: '结束水位不能为空',
          trigger: 'blur'
        },
        {
          validator: (params) => {
            return params.validate.validateEndingWaterLevel
          },
          trigger: 'change'
        }
      ]
    },
    formData: {
      card: '水车作业信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: (params) => {
            return params.pageStatus === 'add' ? 'carInfo' : null
          },
          label: '作业车辆',
          type: 'select',
          placeholder: '请选择当前作业车辆',
          options: (params) => {
            return params.state.officialCar.officialCarList
          },
          valueKey: 'value',
          formKeys: ['carUid', 'carCode', 'driverName', 'paramJson']
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? null : 'carCode'
          },
          label: '作业车辆',
          type: 'input',
          disabled: true
        },
        {
          key: 'driverName',
          label: '驾驶员',
          type: 'input'
        },
        {
          key: 'ratedWaterLevel',
          label: '额定水位',
          type: 'input',
          inputButton: 'm',
          disabled: true
        },
        {
          key: 'startTime',
          label: '开始时间',
          type: 'input',
          disabled: true
        },
        {
          key: 'startingWaterLevel',
          label: '开始水位',
          type: 'input',
          inputButton: 'm',
          disabled: true,
          number: 3,
          placeholder: '通过车辆水位监测设备实时采集数据获取',
          check: (params) => {
            return params.pageStatus === 'add' &&
              params.formValues &&
              params.formValues.carUid
              ? '重新连接'
              : ''
          },
          inputTip: (params) => {
            return (
              params.pageStatus === 'add' &&
              params.formValues &&
              params.formValues.connectInfo
            )
          }
        },
        {
          key: 'startlnglat',
          label: '开始坐标',
          disabled: true,
          type: 'input',
          inputButton: (params) => {
            return params.formValues && params.formValues.startPosition
              ? '地图查看'
              : '获取位置'
          },
          buttonIcon: 'el-icon-location',
          inputTip: (params) => {
            return params.pageStatus === 'add' &&
              params.formValues &&
              params.formValues.startlnglat === '0，0'
              ? '获取位置坐标失败，尝试等待一会儿或手动输入当前位置'
              : ''
          }
        },
        {
          key: 'startPosition',
          label: '开始位置',
          type: 'input',
          placeholder: '根据坐标在地图中获取对应位置，没有坐标请手动输入',
          disabled: (params) => {
            return params.pageStatus === 'edit' ? true : false
          }
        },

        {
          key: (params) => {
            return params.pageStatus === 'add' ? null : 'endTime'
          },
          label: '结束时间',
          type: 'input',
          disabled: true
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? null : 'endingWaterLevel'
          },
          label: '结束水位',
          type: 'input',
          inputButton: 'm',
          disabled: true,
          number: 3,
          placeholder: '通过车辆水位监测设备实时采集数据获取',
          check: (params) => {
            return params.formValues && params.formValues.carUid && '重新连接'
          },
          inputTip: (params) => {
            return params.formValues && params.formValues.connectInfo
          }
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? null : 'endlnglat'
          },
          label: '结束坐标',
          disabled: true,
          type: 'input',
          inputButton: (params) => {
            return params.formValues && params.formValues.endPosition
              ? '地图查看'
              : '获取位置'
          },
          buttonIcon: 'el-icon-location',
          inputTip: (params) => {
            return params.formValues && params.formValues.endlnglat === '0，0'
              ? '获取位置坐标失败，尝试等待一会儿或手动输入当前位置'
              : ''
          }
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? null : 'endPosition'
          },
          label: '结束位置',
          placeholder: '根据坐标在地图中获取对应位置，没有坐标请手动输入',
          type: 'input'
        }
      ]
    }
  }
}

export default waterwheelWork
